import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import './ResultTitleColumns.scss';
import {Stack} from '@mui/material';

const ResultTitleColumns = (
  {
    column1,
    column2,
    column3,
    column4,
    column5,
    column6,
    column7
  }
) => {

  return (
      <Grid container sx={{ flexGrow: 1 }} spacing={4}>
          <Grid className="column1" size={0.3}>{column1}</Grid>
          <Grid className="column2" size={4}><Stack justifyContent="center" sx={{ height: '100%' }}>{column2}</Stack></Grid>
          <Grid className="column3" size={1}><Stack justifyContent="center" sx={{ height: '100%' }}>{column3}</Stack></Grid>
          <Grid className="column4" size={2}><Stack justifyContent="center" sx={{ height: '100%' }}>{column4}</Stack></Grid>
          <Grid className="column5" size={1.5}><Stack justifyContent="center" sx={{ height: '100%' }}>{column5}</Stack></Grid>
          <Grid className="column6" size={1}><Stack justifyContent="center" sx={{ height: '100%' }}>{column6}</Stack></Grid>
          <Grid className="column7" size={2.1}>{column7}</Grid>
      </Grid>
  );
};

ResultTitleColumns.propTypes = {
  column1: PropTypes.node.isRequired,
  column2: PropTypes.node.isRequired,
  column3: PropTypes.node.isRequired,
  column4: PropTypes.node.isRequired,
  column5: PropTypes.node.isRequired,
  column6: PropTypes.node.isRequired,
  column7: PropTypes.node.isRequired
};

ResultTitleColumns.defaultProps = {
};

export default ResultTitleColumns;
